import { AxiosPromise } from "axios";
import { anonymousApi, BaseApi } from "../../shared/api/BaseApi";
import { CustomerMeetingDto } from "./api/CustomerMeetingDto";
import { MeetingLogType } from "../store/MeetingLogType";

export interface MeetingData {
    urlHash: string;
}

export interface MeetingLogData {
    meetingId: string;
    logType: MeetingLogType;
}

export interface RequestCancelMeetingData {
    urlHash: string;
}

export interface CustomerMeetingsService {
    requestCancelMeeting(data: RequestCancelMeetingData): AxiosPromise;
    getMeeting(data: MeetingData): AxiosPromise<CustomerMeetingDto>;
    getOriginJoinUrl(data: MeetingData): AxiosPromise<string>;
    addLog(data: MeetingLogData): AxiosPromise;
}

export class DefaultCustomerMeetingsService implements CustomerMeetingsService {
    private requestCancelMeetingUrl: string = "/customer-meetings/RequestDecline";
    private getMeetingUrl: string = "/customer-meetings/GetMeeting";
    private getOriginJoinUrlEndpointUrl: string = "/customer-meetings/GetOriginJoinUrl";
    private addLogUrl: string = "/customer-meetings/AddLog";

    constructor(private anonymousApi: BaseApi) {}

    requestCancelMeeting(data: RequestCancelMeetingData): AxiosPromise {
        return this.anonymousApi.post(this.requestCancelMeetingUrl, data);
    }

    getMeeting(data: MeetingData): AxiosPromise<CustomerMeetingDto> {
        return this.anonymousApi.post<CustomerMeetingDto>(this.getMeetingUrl, data);
    }

    getOriginJoinUrl(data: MeetingData): AxiosPromise<string> {
        return this.anonymousApi.post<string>(this.getOriginJoinUrlEndpointUrl, data);
    }

    addLog(data: MeetingLogData): AxiosPromise {
        return this.anonymousApi.post(this.addLogUrl, data);
    }
}

export class CustomerMeetingsServiceWithResponse implements CustomerMeetingsService {
    _response: any = {
        data: this.response,
    };

    constructor(private response: any) {}

    requestCancelMeeting() {
        return Promise.resolve(this._response);
    }

    getMeeting() {
        return Promise.resolve(this._response);
    }

    getOriginJoinUrl() {
        return Promise.resolve(this._response);
    }

    addLog() {
        return Promise.resolve(this._response);
    }
}

const customerMeetingsService = new DefaultCustomerMeetingsService(anonymousApi);
export default customerMeetingsService;
